<template>
  <div>
    <Header></Header>
    <full-page :options="options" ref="page">
      <div class="section">
        <div class="mainPage">
        </div>
      </div>
      <div class="section">
        <div class="articlePage">
          <div class="articleCon">
            <div class="div1" @click="showModal(article[0].id)">
              <img :src="article[0].image" alt="">
              <div class="info">
                <div class="title">{{article[0].title}}</div>
                <div class="author">{{article[0].author}}</div>
              </div>
            </div>
            <div class="div2" @click="showModal(article[1].id)">
              <img :src="article[1].image" alt="">
              <div class="info">
                <div class="title">{{article[1].title}}</div>
                <div class="author">{{article[1].author}}</div>
              </div>
            </div>
            <div class="div3" @click="showModal(article[2].id)">
              <img :src="article[2].image" alt="">
              <div class="info">
                <div class="title">{{article[2].title}}</div>
                <div class="author">{{article[2].author}}</div>
              </div>
            </div>
            <div class="div4" @click="showModal(article[3].id)">
              <img :src="article[3].image" alt="">
              <div class="info">
                <div class="title">{{article[3].title}}</div>
                <div class="author">{{article[3].author}}</div>
              </div>
            </div>
            <div class="div5" @click="showModal(article[4].id)">
              <img :src="article[4].image" alt="">
              <div class="info">
                <div class="title">{{article[4].title}}</div>
                <div class="author">{{article[4].author}}</div>
              </div>
            </div>
            <div class="div6" @click="showModal(article[5].id)">
              <img :src="article[5].image" alt="">
              <div class="info">
                <div class="title">{{article[5].title}}</div>
                <div class="author">{{article[5].author}}</div>
              </div>
            </div>
            <div class="div7" @click="showModal(article[6].id)">
              <img :src="article[6].image" alt="">
              <div class="info">
                <div class="title">{{article[6].title}}</div>
                <div class="author">{{article[6].author}}</div>
              </div>
            </div>
          </div>
          <router-link to="/article">
            <div class="listBox">
              <div class="toArticle">ARTICLE</div>
              <div class="homeHr"></div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- <div class="section">
        <div class="magezinePage">
          <div class="cover"></div>
          <div class="title">MAGAZINE</div>
          <div class="listBox">
            <div class="box" v-for="item,index in magazine" :key="index">
              <router-link :to="{name:'/magazine',params:{magazine:item.title}}">
                <div class="con">{{item.title}}</div>
              </router-link>
              <div class="homeHr"></div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="section">
        <div class="activityPage">
          <router-link to="/activity">
            <div class="listBox">
              <div class="toActivity">STEP INTO</div>
              <div class="homeHr"></div>
            </div>
          </router-link>
        </div>
      </div> -->
      <div class="section footer">
        <Footer></Footer>
      </div>
    </full-page>
    <div class="modal" ref="modal">
      <a-modal
          v-model="visible"
          :getContainer="() => $refs.modal"
          width="calc(100vw - 20px)"
          :zIndex=3
          centered
          :footer="null"
          :closable="false"
          :destroyOnClose="true"
          @cancel="onCancel"
      >
        <p v-html="item"></p>
      </a-modal>
      <div class="return" v-if="visible" @click="closeModal"></div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
import Footer from '../../components/Footer.vue'
export default{
  components:{
      Header,
      Footer
  },
  data() {
    return {
      visible: false,
      item:{},
      article:[],
      magazine:[],
      options: {
        // key
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        navigation: false,
        autoScrolling: true
      }
    }
  },
  mounted() {
    this.getData_article()
    this.getData_magazine()
  },
  methods: {
    async getData_article() {
      const articleId = await this.$axios.get("steppyplus", {
      });
      for (let i = 0; i < articleId.data.mobile_article.length; i++) {
        const article = await this.$axios.get("article/"+articleId.data.mobile_article[i], {
        });
        this.article.push(article.data);
      }
    },
    async getArt(id) {
      const article = await this.$axios.get("article/"+id, {
      });
      this.item = article.data.body;
    },
    async getData_magazine() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.magazine = magazine.data;
    },
    showModal(id) {
      this.visible = true;
      this.getArt(id)
      this.options.autoScrolling = false
    },
    closeModal(){
      this.options.autoScrolling = true
      this.visible = false;
      this.item = {}
    },
    onCancel() {
      this.options.autoScrolling = true
    }
  },
}
</script>
<style scoped>
a{
  color: #fff;
}
.homeCon {
  width: 100vw;
  height: fit-content;
  background-color: #000;
}
.footer{
  height: 20px !important;
}
.mainPage,
.magezinePage,
.articlePage,
.activityPage {
  width: calc(100vw - 20px);
  height: calc(100vh - 50px);
  margin: 50px 10px 0 10px;
  background-color: #000;
  /* background: #000; */
}

.homeHr {
  width: calc(100vw - 20px);
  border: none;
  height: 1px;
  background: #888;
}
.mainPage img {
  width: 100%;
  height: inherit;
  object-fit: cover;
}

.articlePage {
  width: calc(100vw - 20px);
  height: calc(100vh - 51px);
  color: #fff;
  padding: 10px 0;
  position: relative;
  box-sizing: border-box;
}

.articlePage .articleCon {
  width: inherit;
  height: 90%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(8, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.articleCon div{
  position: relative;
}
.articleCon div img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.articleCon div .info{
  width: 100%;
  height: fit-content;
  background-image: linear-gradient(to top,rgba(0,0,0,0.7) 50%,rgba(0,0,0,0));
  position: absolute;
  bottom: 0;
  z-index: 1;
  display: flex;
  padding-left: 10px;
  flex-direction: column;
  justify-content: flex-end;
}
.articleCon div .info .title {
  font-size: 13px;
  line-height: 20px;
}
.articleCon div .info .author {
  font-size: 12px;
  line-height: 20px;
}
.articleCon .div1 {
  grid-area: 1 / 1 / 3 / 4;
  background: #888;
}

.articleCon .div2 {
  grid-area: 1 / 4 / 3 / 6;
  background: #888;
}

.articleCon .div3 {
  grid-area: 3 / 1 / 5 / 3;
  background: #888;
}

.articleCon .div4 {
  grid-area: 5 / 1 / 7 / 3;
  background: #888;
}

.articleCon .div5 {
  grid-area: 3 / 3 / 7 / 6;
  background: #888;
}

.articleCon .div6 {
  grid-area: 7 / 1 / 9 / 4;
  background: #888;
}

.articleCon .div7 {
  grid-area: 7 / 4 / 9 / 6;
  background: #888;
}
.articlePage .listBox {
  width: 100%;
  height: fit-content;
  text-align: right;
  font-size: 30px;
  position: absolute;
  bottom: 10px;
}
.articlePage .listBox .toArticle{
  width: inherit;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.articlePage .listBox .toArticle::after{
  content: url('../../assets/enterIcon.png');
  width: 30px;
  height: 30px;
  transform: scale(0.8);
}
.modal /deep/ .ant-modal {
    max-width: 100vw;
    height: calc(100vh - 70px);
    overflow: hidden;
    padding: 0;
    margin: 0;
    border-radius: 0;
}
.modal /deep/ .ant-modal-wrap {
    width: calc(100vw);
    height: calc(100vh - 70px);
    transform: translateY(60px);
}
.modal /deep/ .ant-modal-mask{
  background-color: #000;
}
.modal /deep/ .ant-modal-content {
  height: calc(100vh - 100px);
  overflow: hidden;
  background-color: #000;
  border: #888 1px solid;
  color: #888;
}
.modal /deep/ .ant-modal-body {
  height: calc(100vh - 100px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal /deep/ .ant-modal-body img,
.modal /deep/ .ant-modal-body svg{
  width: 100% !important;
  max-width: 100%;
  height: auto !important;
  object-fit: contain;
}
.modal /deep/ .ant-modal-body h1{
  color: #fff;
  font-size: 18px;
}
.modal /deep/ .ant-modal-body p,
.modal /deep/ .ant-modal-body span,
.modal /deep/ .ant-modal-body strong,
.modal /deep/ .ant-modal-body section{
  color: #fff !important;
  /* background-color: #000 !important; */
  background-image: none !important;
  margin: 0;
  filter: drop-shadow(0 0 0.4px #000);
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar {
  width: 15px;
  background: #000;
  border: 1px solid #888;
  display: block;
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar-thumb {
  background-color: #fff;
}
.modal .return {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: fixed;
  z-index: 5;
  right: 30px;
  bottom: 20px;
  background: #000 url("../../assets/return.png") center no-repeat;
  background-size: 60%;
}
.modal .last {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: fixed;
  z-index: 5;
  left: 30px;
  bottom: 20px;
  background: #000 url("../../assets/last.png") center no-repeat;
  background-size: 30%;
}
.modal .next {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: fixed;
  z-index: 5;
  left: 80px;
  bottom: 20px;
  background: #000 url("../../assets/next.png") center no-repeat;
  background-size: 30%;
}
.magezinePage {
  height: calc(100vh - 51px);
  color: #fff;
  padding: 10px 0;
  position: relative;
}

.magezinePage .cover{
  width: inherit;
  height: 60%;
  background: transparent url('../../assets/magezine_M.png') center no-repeat;
  background-size: contain;
}
.magezinePage .title{
  font-size: 40px;
  font-weight: bold;
  position: absolute;
  bottom: 240px;
  right: 0;
}
.magezinePage .listBox {
  width: inherit;
  height: fit-content;
  text-align: right;
  font-size: 24px;
  position: absolute;
  bottom: 10px;
}

.magezinePage .listBox .box{
  width: inherit;
}
.magezinePage .listBox .box .con{
  width: inherit;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.magezinePage .listBox .box .con::after {
  content: url('../../assets/enterIcon.png');
  width: 30px;
  height: 30px;
  transform: scale(0.8);
}

.activityPage {
  height: calc(100vh - 51px);
  color: #fff;
  padding: 10px 0;
  position: relative;
  background: transparent url('../../assets/stepinto_M.png') center no-repeat;
  background-size: contain;
}

.activityPage .listBox {
  width: inherit;
  height: fit-content;
  text-align: right;
  font-size: 30px;
  position: absolute;
  bottom: 10px;
}

.activityPage .listBox .toActivity {
  width: inherit;
  display: flex;
  justify-content: space-between;
}

.activityPage .listBox .toActivity::after {
  content: url('../../assets/enterIcon.png');
  width: 30px;
  height: 30px;
  transform: scale(0.8);
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/Home.vue